import { sharedService } from "@/modules/shared/store/services/shared-service";
import { populateRateValueTypes } from "@/redux/reducers/rateValueTypes";

const getRateValueTypes = sharedService.injectEndpoints({
  endpoints: builder => ({
    getRateValueTypes: builder.query({
      query: () => "parameters/rate-value-types",
      transformResponse: response => response.items,
      providesTags: ["RateValueTypes"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(populateRateValueTypes(data));
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetRateValueTypesQuery } = getRateValueTypes;

